
/**
 * AppViewReceiverConst
 *
 * イベントの処理実体を指し示す定義クラス
 * インナークラスをネストして、ドメイン、UI区分、ドメイン、処理名称のクラスを作成する
 * 最終的に示されるのは処理名称のプロパティで、stringを設定する
 *
 * イベント元と処理実体で、処理実体の実装箇所を指し示すために使用される。
 */
export class AppViewReceiverConst {

	////////////////////////////////////
	// Managementドメイン区分
	public static readonly Management = class UIDivision {

		// ※※※※  先頭は大文字にする事 ※※※※※※
		// 呼び出されるクラス側メソッド名は、先頭小文字。
		// ここの定義は、定数なので、先頭大文字で統一。。
		// ※※※※※※※※※※※※※※※※※※※※※※

		// 継承区分のクラスを各UI区分のプロパティに設定する
		// プロパティに入っているのは、継承区分のBaseとComponentのプロパティを持ったクラス
		// View区分
		public static readonly View = class ClassName {

		};
		// Display区分
		public static readonly Display = class ClassName {

			public static readonly ManagementDisplayComponent = class MethodName {

			};
		};
		// Fragment区分
		public static readonly Fragment = class Classname {

			// 企業管理Fragment
			public static readonly CompanyManagementFragmentComponent = class MethodName {

				// アニメーションで遷移するイベント
				public static readonly ChangeMovePanelView = 'ChangeMovePanelView';
				// パネルを閉じる前に前パネルを戻すイベント
				public static readonly VisiblePanelView = 'VisiblePanelView';
				// アニメーションでパネルを閉じるイベント
				public static readonly CloseMovePanelView = 'CloseMovePanelView';
				// ポップアップを表示するイベント
				public static readonly ShowPopUp = 'ShowPopUp';

				// スライドの一括削除イベント
				public static readonly AllCloseMovePanelView = 'AllCloseMovePanelView';

			};


		};
		// Panel区分
		public static readonly Panel = class ClassName {

		};
	};


	////////////////////////////////////
	// Userドメイン区分
	public static readonly User = class UIDivision {

		// View区分
		public static readonly View = class ClassName {

		};
		// Display区分
		public static readonly Display = class ClassName {

		};

		// Fragment区分
		public static readonly Fragment = class ClassName {

			public static readonly DiagnoseFragmentComponent = class MethodName {

				// ホーム画面に遷移する
				public static readonly ChangeHomeFromExam = 'ChangeHomeFromExam';
				// 受験画面に遷移する
				public static readonly ChangeExam = 'ChangeExam';
				// 面談回答画面に遷移する
				public static readonly ChangeReplyCounsel = 'ChangeReplyCounsel';
				// アニメーションで遷移するイベント
				public static readonly ChangeMovePanelView = 'ChangeMovePanelView';
				// パネルを閉じる前に前パネルを戻すイベント
				public static readonly VisiblePanelView = 'VisiblePanelView';
				// アニメーションでパネルを閉じるイベント
				public static readonly CloseMovePanelView = 'CloseMovePanelView';

			};

			public static readonly MyPageFragmentComponent = class MethodName {

				// ホーム画面に遷移する
				public static readonly ChangeHomeFromExam = 'ChangeHomeFromExam';
				// 受験画面に遷移する
				public static readonly ChangeExam = 'ChangeExam';
				// 面談回答画面に遷移する
				public static readonly ChangeReplyCounsel = 'ChangeReplyCounsel';
				// アニメーションで遷移するイベント
				public static readonly ChangeMovePanelView = 'ChangeMovePanelView';
				// パネルを閉じる前に前パネルを戻すイベント
				public static readonly VisiblePanelView = 'VisiblePanelView';
				// アニメーションでパネルを閉じるイベント
				public static readonly CloseMovePanelView = 'CloseMovePanelView';

			};

			public static readonly PaymentFragmentComponent = class MethodName {

				// ホーム画面に遷移する
				public static readonly ChangeHomeFromExam = 'ChangeHomeFromExam';
				// 受験画面に遷移する
				public static readonly ChangeExam = 'ChangeExam';
				// 面談回答画面に遷移する
				public static readonly ChangeReplyCounsel = 'ChangeReplyCounsel';
				// アニメーションで遷移するイベント
				public static readonly ChangeMovePanelView = 'ChangeMovePanelView';
				// パネルを閉じる前に前パネルを戻すイベント
				public static readonly VisiblePanelView = 'VisiblePanelView';
				// アニメーションでパネルを閉じるイベント
				public static readonly CloseMovePanelView = 'CloseMovePanelView';

			};

			public static readonly ReserveFragmentComponent = class MethodName {

				// ホーム画面に遷移する
				public static readonly ChangeHomeFromExam = 'ChangeHomeFromExam';
				// 受験画面に遷移するd
				public static readonly ChangeExam = 'ChangeExam';
				// 面談回答画面に遷移する
				public static readonly ChangeReplyCounsel = 'ChangeReplyCounsel';
				// アニメーションで遷移するイベント
				public static readonly ChangeMovePanelView = 'ChangeMovePanelView';
				// パネルを閉じる前に前パネルを戻すイベント
				public static readonly VisiblePanelView = 'VisiblePanelView';
				// アニメーションでパネルを閉じるイベント
				public static readonly CloseMovePanelView = 'CloseMovePanelView';

			};

		};
		// Panel区分
		public static readonly Panel = class ClassName {

		};

	};

	////////////////////////////////////
	// 共通　ドメイン区分　＝＞ AppMainView近辺のみ
	public static readonly General = class UIDivision {

		// View区分
		public static readonly View = class ClassName {
			// AppAdminViewでイベントが処理される名称
			public static readonly AppMainViewComponent = class MethodName {

				// リマインド処理
				public static readonly LoginForgotPassword = 'LoginForgotPassword';
				// 再表示処理（ログアウト後、HOME表示）
				public static readonly Redisplay = 'Redisplay';

				// スピナーの表示処理
				public static readonly ShowSpinner = 'ShowSpinner';
				// スピナーの非表示処理
				public static readonly CloseSpinner = 'CloseSpinner';

			};

			// AppAdminViewでイベントが処理される名称
			public static readonly LoginViewComponent = class MethodName {

				// リマインド処理
				public static readonly LoginForgotPassword = 'LoginForgotPassword';
				// 再表示処理（ログアウト後、HOME表示）
				public static readonly Redisplay = 'Redisplay';

				// スピナーの表示処理
				public static readonly ShowSpinner = 'ShowSpinner';
				// スピナーの非表示処理
				public static readonly CloseSpinner = 'CloseSpinner';

			};

		};
		// Display区分
		public static readonly Display = class ClassName {

		};

	};


}
